import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { IOptionButtonProps } from './option-button.models';
import styles from './option-button.module.css';
import classNames from 'classnames';

export const OptionButton = forwardRef<HTMLButtonElement, IOptionButtonProps>((props, outerRef) => {
  const { small, children, disabled, onClick } = props;

  const cleansedProps = {
    ...props,
    small: undefined,
    children: undefined,
    disabled: undefined,
  };

  const innerRef = useRef<HTMLButtonElement>(null);
  useImperativeHandle(outerRef, () => innerRef.current!, []);

  return (
    <button
      {...cleansedProps}
      ref={innerRef}
      type="button"
      className={classNames(styles.optionButton, { [styles.small]: small })}
      aria-disabled={disabled}
      onClick={event => {
        if (disabled) return;
        if (!!onClick) return onClick(event);
      }}
    >
      {children}
    </button>
  );
});

OptionButton.displayName = 'OptionButton';
